import * as DSAssetFamilies from './DSAssetFamilies';
import * as ObjectTypes from 'customer-data-objects/constants/ObjectTypes';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import * as ReferenceObjectTypes from 'reference-resolvers/constants/ReferenceObjectTypes';
import { Map as ImmutableMap } from 'immutable';
export const ObjectTypeToDSAssetFamily = ImmutableMap({
  [ObjectTypes.COMPANY]: DSAssetFamilies.COMPANY_PROPERTY,
  [ObjectTypes.CONTACT]: DSAssetFamilies.CONTACT_PROPERTY,
  [ObjectTypes.DEAL]: DSAssetFamilies.DEAL_PROPERTY,
  [ObjectTypes.TICKET]: DSAssetFamilies.TICKET_PROPERTY,
  [ObjectTypes.ENGAGEMENT]: DSAssetFamilies.ENGAGEMENT_PROPERTY,
  [ObjectTypes.LINE_ITEM]: DSAssetFamilies.LINE_ITEM_PROPERTY,
  [ObjectTypes.PRODUCT]: DSAssetFamilies.PRODUCT_PROPERTY,
  [ObjectTypes.QUOTE]: DSAssetFamilies.QUOTE_PROPERTY,
  [ObjectTypes.TASK]: DSAssetFamilies.TASK_PROPERTY,
  [ObjectTypes.GOAL_TARGET]: DSAssetFamilies.GOAL_TARGET_PROPERTY
});
export const DSAssetFamilyToObjectType = ObjectTypeToDSAssetFamily.flip();
export const ObjectSegTypeToDSAssetFamily = ImmutableMap({
  [ObjectTypes.COMPANY]: DSAssetFamilies.COMPANY_PROPERTY,
  [ObjectTypes.CONTACT]: DSAssetFamilies.CONTACT_PROPERTY,
  [ObjectTypes.DEAL]: DSAssetFamilies.DEAL_PROPERTY,
  [ObjectTypes.TICKET]: DSAssetFamilies.TICKET_PROPERTY,
  [ObjectTypes.ENGAGEMENT]: DSAssetFamilies.ENGAGEMENT_PROPERTY,
  [ObjectTypes.LINE_ITEM]: DSAssetFamilies.LINE_ITEM_PROPERTY,
  [ObjectTypes.PRODUCT]: DSAssetFamilies.PRODUCT_PROPERTY,
  [ObjectTypes.QUOTE]: DSAssetFamilies.QUOTE_PROPERTY
});
export const DSAssetFamilyToObjectSegType = ObjectSegTypeToDSAssetFamily.flip();
export const referenceTypeToAssetFamily = ImmutableMap({
  [ReferenceObjectTypes.ADS_PROPERTY]: DSAssetFamilies.ADS_PROPERTY,
  [ReferenceObjectTypes.CONTACT_LIST]: DSAssetFamilies.CONTACT_LIST,
  [ReferenceObjectTypes.CTA]: DSAssetFamilies.CTA,
  [ReferenceObjectTypes.CTA_TO_PLACEMENT]: DSAssetFamilies.CTA_TO_PLACEMENT,
  [ReferenceObjectTypes.EMAIL_CAMPAIGN]: DSAssetFamilies.EMAIL_CAMPAIGN,
  [ReferenceObjectTypes.ENGAGEMENT_PROPERTY]: DSAssetFamilies.ENGAGEMENT_PROPERTY,
  [ReferenceObjectTypes.EVENT]: DSAssetFamilies.EVENT,
  [ReferenceObjectTypes.INBOUND_DB_CONTACT_IMPORT]: DSAssetFamilies.CONTACT_IMPORT,
  [ReferenceObjectTypes.INTEGRATION]: DSAssetFamilies.INTEGRATION,
  [ReferenceObjectTypes.LINE_ITEM_PROPERTY]: DSAssetFamilies.LINE_ITEM_PROPERTY,
  [ReferenceObjectTypes.PRODUCT_PROPERTY]: DSAssetFamilies.PRODUCT_PROPERTY,
  [ReferenceObjectTypes.SURVEY]: DSAssetFamilies.SURVEY_MONKEY_SURVEY,
  [ReferenceObjectTypes.SURVEY_QUESTION]: DSAssetFamilies.SURVEY_MONKEY_QUESTION,
  [ReferenceObjectTypes.WEBINAR]: DSAssetFamilies.GOTO_WEBINAR_WEBINAR
});
export const assetFamilyToReferenceType = referenceTypeToAssetFamily.flip();